import React, { useState } from 'react';
import { Input, Button, Space, message } from 'antd';

interface RefOemManagerProps {
  title: string;
  data: { [key: string]: string[] };
  setData: React.Dispatch<React.SetStateAction<{ [key: string]: string[] }>>;
}

const RefOemManager: React.FC<RefOemManagerProps> = ({ title, data, setData }) => {
  const [model, setModel] = useState('');
  const [code, setCode] = useState('');
  const [selectedKeys, setSelectedKeys] = useState<string[]>([]);

  const handleAdd = () => {
    if (model.trim() && code.trim()) {
      setData(prev => ({
        ...prev,
        [model]: prev[model] ? [...prev[model], code] : [code],
      }));
      setModel('');
      setCode('');
    } else {
      message.warning(`Заполните оба поля для ${title}`);
    }
  };

  const handleDeleteSelected = () => {
    setData(prev => {
      const updated = { ...prev };
      selectedKeys.forEach(key => {
        const [group, indexStr] = key.split('___');
        const index = parseInt(indexStr);
        if (updated[group]) {
          updated[group].splice(index, 1);
          if (updated[group].length === 0) delete updated[group];
        }
      });
      return updated;
    });
    setSelectedKeys([]);
  };

  return (
    <>
      <label style={{ fontWeight: 'bold', marginRight: 16 }}>{title}</label>
      <Space style={{ marginBottom: 8 }}>
        <Input placeholder={`${title} Group`} value={model} onChange={(e) => setModel(e.target.value)} />
        <Input placeholder={`${title} Code`} value={code} onChange={(e) => setCode(e.target.value)} />
        <Button type="primary" onClick={handleAdd}>Добавить</Button>
        <Button danger onClick={() => { setModel(''); setCode(''); }}>Отменить</Button>
      </Space>
      <div style={{
        border: '1px solid #ccc', borderRadius: '8px', backgroundColor: '#f8f8f8',
        padding: '10px', marginBottom: 12, maxHeight: 180, overflowY: 'auto'
      }}>
        {Object.entries(data).map(([group, values]) => (
          <div key={group} style={{ marginBottom: 12 }}>
            <div style={{ color: '#b70000', fontWeight: 'bold', marginBottom: 4 }}>{group}</div>
            {values.map((val, index) => {
              const key = `${group}___${index}`;
              return (
                <div key={key} style={{ display: 'flex', alignItems: 'center', marginBottom: 4 }}>
                  <input
                    type="checkbox"
                    style={{ marginRight: 8 }}
                    checked={selectedKeys.includes(key)}
                    onChange={(e) => {
                      setSelectedKeys(prev =>
                        e.target.checked ? [...prev, key] : prev.filter(k => k !== key)
                      );
                    }}
                  />
                  <div style={{
                    backgroundColor: '#e0e0e0', padding: '6px 10px',
                    borderRadius: '4px', flex: 1
                  }}>{val}</div>
                </div>
              );
            })}
          </div>
        ))}
        {selectedKeys.length > 0 && (
          <Button danger size="small" onClick={handleDeleteSelected}>Удалить выбранное</Button>
        )}
      </div>
    </>
  );
};

export default RefOemManager;
